import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {confirmAlert} from "react-confirm-alert";
import ReactToPrint from "react-to-print";

import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";
import ObjectOverride from "components/ObjectOverride";
import Access from "constants/Access";
import {PrintBarcodeModal} from '../../containers/Print';
import TextField from "@material-ui/core/TextField";
import API from "@beardeddevops/react.api";


/**
 *  @property {Products_Object} state
 *  @property {object} model
 *  @property {Products_Properties} model.properties
 *  @property {Products_Is} model.is
 *  @property {Products_Has} model.has
 */

class UPC extends ObjectOverride {
	constructor(props) {

		super(props, Types.Upc_Center._name);
		//this.model.serial_number.ux_validation = false;
		this.printLabel = this.printLabel.bind(this)
		this.state.bound_book_note = '';
		this.state.modal = false;
		this.state.atfModalPop = null;

	}

	shortLabelRef = null;
	longLabelRef = null;

	/**
	 * @param prevProps
	 * @param {Products_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate (prevProps, prevState, snapshot)  {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		/** @type {Products_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.serial_number);
		}

	}

	componentDidMount() {
		super.componentDidMount();
		this.state.atfRequired = ['serial_number',  'manufacturer',  'manufacturer_other',  'model',  'barrel_length',  'overall_length',
			'acquisition',  'type',  'importer',  'model',  'caliber',  'caliber_other'];
	}



	printLabel() {
		let object = this.state
		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={<ProductLong product={object}/>}
						shortBarCode={<ProductShort product={object}/>}
					/>
				);
			}
		});
	}

	// handleModalSave = async () => {
	// 	await super.handleSubmit();
	// 	this.toggle();
	// 	this.state.change_note = '';
	// }

	handleModalToggle = async () => {
		if(this.state.atfModalPop) {
			this.toggle()
			this.state.atfModalPop = false
		}
		else {
			await super.handleSubmit();
		}
	}

	toggle = () => {
		this.setState({modal: !this.state.modal})
	}

	handleTextFieldOverride = (e, value) => {
		this.handleTextFieldPropertyUpdate(e, value);
		if(this.state.atfRequired.includes(e)) {
			this.state.atfModalPop = true;
		}
	}

	handleSelectOverride = (e, value) => {
		if(this.state.manufacturer_copy !== this.state.manufacturer || this.state.caliber_copy !== this.state.caliber && this.state.type_copy !== this.state.type) {
			this.state.atfModalPop = true;
		}
		this.handleSelectPropertyUpdate(e, value)
	}

	async handleSubmit() {
		if(this.state.account === null) {
			let upcModel = new API.BuildClass(Types.Upc_Center._name, API.RequestType.CREATE);
			upcModel.object = this.state;
			let result = await upcModel.submit(null, API.RequestType.CREATE);
			this.props.history.push(`/products/upc_center/${result.binary_id}-${result.pkey}`);
		}
		else {
			await super.handleSubmit();
		}
	}


	form = () => {
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let exists = object.pkey;
		return (
			<div>
				<fieldset>

					<div className={"row"}>

						<div className={"col-md"}>
							{/*#region ATF Required Information*/}
							<h4 className="section-title">ATF Required Information</h4>

							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									name="manufacturer"
									property={properties.manufacturer}
									value={object.manufacturer}
									error={object.manufacturer_error}
									object={object.manufacturers}
									nullable={true}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.manufacturer_other}
									error={object.manufacturer_other_error}
									property={properties.manufacturer_other}
									update={this.handleTextFieldOverride}
									label={"Manufacturer (Manual Entry)"}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer (If Imported)"}
									value={object.importer}
									error={object.importer_error}
									property={properties.importer}
									update={this.handleTextFieldOverride}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Model"}
									value={object.model}
									error={object.model_error}
									property={properties.model}
									update={this.handleTextFieldOverride}
								/>
							</div>
							<div className="form-group" data-id="caliber">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectOverride}
									property={properties.caliber}
									value={object.caliber}
									error={object.caliber_error}
									object={object.calibers}
									nullable={true}
									default={{value: '', label: 'Other (Manual Entry)'}}
									defaultFirst={true}
								/>
							</div>
							{!object.caliber &&	<div className="form-group">
								<Framework.Elements.TextField
									label={"Caliber (Manual Entry)"}
									value={object.caliber_other}
									error={object.caliber_other_error}
									property={properties.caliber_other}
									update={this.handleTextFieldOverride}
								/>
							</div>}
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Barrel Length"}
											value={object.barrel_length}
											error={object.barrel_length_error}
											property={properties.barrel_length}
											update={this.handleTextFieldOverride}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Overall Length"}
											value={object.overall_length}
											error={object.overall_length_error}
											property={properties.overall_length}
											update={this.handleTextFieldOverride}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}
						</div>
						<div className={"col-md"}>
							{/*#region Product Details*/}
							<h4 className="section-title">Product Details</h4>
							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<span className="input-label">New/Used Item</span>
									</div>
									<div className="col-6 text-right">
										<Framework.Elements.ButtonSwitch
											property={properties.used_firearm}
											value={object.used_firearm}
											error={object.used_firearm_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Used'}
											labelFalse={'New'}
										/>

									</div>
								</div>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"UPC"}
									value={object.upc}
									error={object.upc_error}
									property={properties.upc}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Product Description"}
									value={object.item_description}
									error={object.item_description_error}
									property={properties.item_description}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							{
								((object.type === 'Rifle' || object.type === 'Rifle / Shotgun') && this.props.locations.some((location) => {
									let borderStates = ["AZ", "TX", "NV", "CA"]
									return borderStates.includes(location.state)
								})) &&
								<div style={{marginTop: '-10px', marginBottom: '1rem', textAlign: 'right'}}>
									<p style={{marginBottom: '2px', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>Semi-automatic rifle with a
										detachable magazine?</p>
									<Framework.Elements.ButtonSwitch
										property={properties.semi_auto_w_detach}
										value={object.semi_auto_w_detach}
										error={object.semi_auto_w_detach_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
									/>
								</div>
							}
							{/*#endregion*/}

						</div>
						<div className={"col-md"}>
							<div className={"row"}>
								<div className={"col-md-4"}>
									<h4 className="section-title">Cost</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Cost"}
											value={object.cost}
											error={object.cost_error}
											property={properties.cost}
											update={this.handleTextFieldOverride}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<h4 className="section-title">Min Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Min Price"}
											value={object.price_min}
											error={object.price_min_error}
											property={properties.price_min}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<h4 className="section-title">List Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"List Price"}
											value={object.price_list}
											error={object.price_list_error}
											property={properties.price_list}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<h4 className="section-title">Label Preview</h4>
							<div style={{textAlign: 'center'}}>
								<ProductLong product={object} visible={true} />
							</div>



						</div>



					</div>


				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
				<Modal
					isOpen={this.state.modal}
					toggle={this.toggleClose}
					size={"md"}
					backdrop={true}
					keyboard={true}
				>


					<ModalHeader toggle={this.toggleClose}>
						{"Bound Book Note"}
					</ModalHeader>
					<ModalBody>
						<div className={"row"}>
							<div className={"col-12"}>
								<div className={"form-group"}>
									<TextField
										fullWidth={true}
										size={"medium"}
										label={"Bound Book Note"}
										value={this.state.change_note}
										onChange={(e) => this.setState({change_note: e.currentTarget.value})}
										variant="outlined"
									/>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={this.toggle}>Cancel</Button>
						<Button color="primary" onClick={this.handleSubmit}>Save</Button>
					</ModalFooter>
				</Modal>
			</div>
		)
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					{/*<Button color="default" onClick={this.printLabel} style={{marginRight: 'auto'}}>Print Label</Button>*/}
					{this.props.rootState.userAccess <= Access.Manager && (!this.state.product_statuses|| this.state.product_statuses.pkey===8) &&
						<Button color="danger" onClick={this.handleDelete}>Delete</Button>}
					<Button color="primary" onClick={this.handleSubmit}>Save
					</Button>
				</CardActions>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(UPC);
